import i18n from 'i18next'

export async function refreshTranslations() {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('i18next_res_')) {
      localStorage.removeItem(key)
    }
  })

  const languages = i18n.languages || [i18n.language]
  const namespaces = i18n.options.ns || []

  try {
    await i18n.reloadResources(languages, namespaces)

    await i18n.changeLanguage(i18n.language)
  } catch (error) {
    console.error('Failed to reload translations:', error)
  }
}
